import Button from '@/components/UI/Button';
import Card from '@/components/UI/Card/index.tsx';
import Table from '@/features/ChangeOrder/Summary/Table';
import { columns } from './columns';
import { mockProjectReports } from './data';

export function ProjectReports() {
  return (
    <Card title='Project Reports' titleElement={<Button btnStyle='btn-primary' label='Add New' />}>
      <Table tableClassName='!w-full' wrapperClassName='overflow-visible' cols={columns} data={mockProjectReports} />
    </Card>
  );
}
